<script lang="ts" setup>
definePageMeta({
  title: 'Settings'
})
</script>

<template>
  <PageSettings />
</template>
